import { Injectable, inject } from '@angular/core';
import { BlockUIService } from 'ng-block-ui';

@Injectable({
  providedIn: 'root'
})
export class LoadingService {

  private readonly blockUIService = inject(BlockUIService);

  private readonly target = 'root';

  start() {
    this.blockUIService.start(this.target);
  }

  stop() {
    this.blockUIService.stop(this.target);
  }
}
